import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, defaultLang } from "../lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return defaultLang;
    return localStorage.getItem("sg_lang") || defaultLang;
  });

  useEffect(() => {
    localStorage.setItem("sg_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => {
    const dict = translations[lang] || translations[defaultLang];
    return (key, n) => {
      if (n === undefined) return dict[key] ?? key;
      const s = (n === 1 && dict[`${key}_one`]) || dict[key] || key;
      return s.replace("{n}", n);
    };
  }, [lang]);

  const toggle = () => setLang((l) => (l === "en" ? "es" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
